<template>
  <li class="note">
    <div class="note-text">{{ note.text }}</div>
    <div class="avatar-container">
      <div class="author avatar">{{ note.author | initials }}</div>
      <div class="avatar" v-for="voter in note.votes" :key="voter.index">
        {{ voter | initials }}
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: "Note",
  props: {
    note: Object
  },
  filters: {
    initials: function(value) {
      if (!value) return "";
      return value.toString().substring(0, 2);
    }
  }
};
</script>

<style scoped>
.note {
  display: grid;
  cursor: pointer;
  background-color: white;
  padding: 10px;
  border-radius: 3px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.note:hover {
  background-color: #f4f5f7;
}

.note:not(:last-child) {
  margin-bottom: 6px;
}

.avatar-container {
  margin-top: 10px;
  display: grid;
  height: 30px;
  align-items: center;
  justify-items: left;
  grid-template-columns: 30px auto;
  grid-auto-flow: column;
  grid-gap: 5px;
  grid-auto-columns: 28px;
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--yellow);
  user-select: none;
  justify-self: end;
  color: var(--black);
}

.author {
  justify-self: start;
  color: white;
  background-color: var(--black);
}
</style>
